import Component from 'component';
import _debounce from 'lodash/debounce';
import { jumpToTarget } from '../helpers/jumpToTarget';

class HeaderLocalized extends Component {
  constructor(el, config) {
    super(el, config);
  }

  setupDefaults() {
    this.dom = {
      $formLabel: this.$el.find('.zip-locator__link--label'),
      $zipLink: this.$el.find('a.zip-locator__link')
    };
  }

  addListeners() {
    this.dom.$formLabel.on('touchstart click', ::this.onFormLabel);
    this.dom.$zipLink.on('touchstart click', ::this.onZipLink);
  }

  onFormLabel() {
    this.$el.addClass('header--open-form');
  }

  onZipLink(e) {
    e.stopPropagation();

    const anchor = this.dom.$zipLink.attr('href');

    jumpToTarget(anchor);
  }
}

export default HeaderLocalized;



// WEBPACK FOOTER //
// ./src/apm/js/components/HeaderLocalized.js